import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import FullScreenLoader from "../components/FullScreenLoader";
import WelcomeHeader from "components/Home/WelcomeHeader";
import { PageLayout } from "components/Layout/PageLayout";
import StepperForm from "components/Stepper/stepper";

const HomePage = () => {



  // API

 

  if (
   false
  ) {
    return <FullScreenLoader />;
  }

  return (
    <PageLayout>
      {/* Partner logo */}
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        alignItems={"center"}
        sx={{
          flex : 1,
          width: "100%",
          backgroundColor: "#d9d9d9",
          padding: "20px",
          "@media (max-width: 600px)": {
            padding: "5px",
          },
          height: "100%",
        }}
      >
        <StepperForm/>
        
      </Box>
    </PageLayout>
  );
};

export default HomePage;
